import { InputDateFilter } from '@/components';
import { formatDate } from '@/utils/formatDate';
import {
  ColumnProps,
  ColumnFilterElementTemplateOptions,
} from 'primereact/column';
import ModalDetails from './components/ModalDetails';

export const getTableColumns = (): ColumnProps[] => {
  // eslint-disable-next-line no-console

  return [
    {
      field: 'selection',
      header: '',
      filter: false,
      showFilterMenu: false,
      sortable: false,
      selectionMode: 'multiple',
      headerStyle: { width: '3rem' },
    },
    {
      field: 'numero',
      header: 'Número proforma',
      filter: false,
      showFilterMenu: false,
      sortable: true,
      body: (rowData) => <strong>{rowData?.numero}</strong>,
    },
    {
      field: 'fecha',
      header: 'Fecha de proforma',
      filter: false,
      showFilterMenu: false,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} />
      ),
      body: (rowData) => formatDate(rowData?.fecha),
    },
    {
      field: 'importe',
      header: 'Importe (USD)',
      filter: false,
      sortable: true,
      body: (rowData) => `$${rowData?.importe?.toFixed(2)}`,
    },
    {
      field: 'modalDetails',
      header: 'Ver',
      filter: false,
      showFilterMenu: false,
      sortable: false,
      headerStyle: { width: '3rem' },
      body: (rowData) => (
        <div className="flex justify-center">
          <ModalDetails oid={rowData?.numero} rowData={rowData} />
        </div>
      ),
    },
  ];
};
